import getBoldedText from "@insite/client-framework/Common/Utilities/getPatternBolded";
import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";
import { autocompleteSearch } from "@insite/client-framework/Services/AutocompleteService";
import { ProductAutocompleteItemModel } from "@insite/client-framework/Types/ApiModels";

type Parameter = { query: string; relevancy?: boolean; allSites?: boolean };

type Props = {
    apiResult: ProductAutocompleteItemModel[] | null;
};

type HandlerType = Handler<Parameter, Props>;

export const DispatchBeginSearchProducts: HandlerType = props => {
    props.dispatch({
        type: "Components/ProductSelector/BeginSearchProducts",
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    if (props.parameter.query.length > 0) {
        const apiParameter = {
            ...props.parameter,
            productEnabled: true,
            brandEnabled: false,
            categoryEnabled: false,
            contentEnabled: false,
        };

        props.apiResult = (await autocompleteSearch(apiParameter as any)).products;

        if (props.apiResult) {
            props.apiResult.forEach(product => {
                product.displayTitle = getBoldedText(product.title, props.parameter.query);
                product.displayErpNumber = getBoldedText(product.erpNumber, props.parameter.query);
            });
        }
    }
};

export const DispatchCompleteSearchProducts: HandlerType = props => {
    props.dispatch({
        type: "Components/ProductSelector/CompleteSearchProducts",
        result: props.apiResult,
    });
};

export const chain = [DispatchBeginSearchProducts, RequestDataFromApi, DispatchCompleteSearchProducts];

const defaultParameter: Parameter = { query: "", relevancy: true };
const searchProducts = createHandlerChainRunnerOptionalParameter(chain, defaultParameter, "SearchProducts");
export default searchProducts;
